export default __webpack_public_path__ + "static/media/gummy@2x.26b0192d.png";